import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
// import "./resetPassword.scss";
import masterApi from "../../services/masterApi";
import logo from "../../assets/images/logo.png";

const ResetPassword = ({ closeResetPassword }) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [viewLoader, setViewLoader] = useState(false);
  const { handleLogout } = useContext(AuthContext);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setViewLoader(true);
    try {
      const userData = await masterApi.resetPassword({ data });
      if (userData?.data?.ok) {
        setSuccess("Password reset successfully. Redirecting...");
        setTimeout(() => {
          handleLogout();
        }, 2000);
      } else {
        setViewLoader(false);
        setError(error.response?.data?.message || "Failed to reset password.");
      }
    } catch (err) {
      setViewLoader(false);
      setError(err.response?.data?.message || "Something went wrong!");
      console.error("Password reset failed:", err.message);
    }
  };
  const onReset = () => {
    navigate("../");
  };

  return (
    <div className="main-login-area">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>

        </div>
      </div>
      <div className="auth-page-content d-flex">
        <div className="container pt-5">
          <div className="justify-content-center row h-100 d-flex align-content-center pt-3">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card">
                <div className="p-4 card-body">
                  <div className="login-box">
                    <div className="box-left">
                      <div className="login-content-area">
                        <div className="logo-img text-center mb-4">
                          <img src={logo} alt="Logo" />
                        </div>
                        <div className="reset-password">
                          <h5 className="text-center mb-4">Reset Password</h5>
                          {error && <div className="alert space-between danger">{error}</div>}
                          {success && <div className="alert space-between success-color">{success}</div>}

                          <form className="reset-form" onSubmit={handleSubmit(onSubmit)}>
                            {/* Old Password */}
                            <div className="row">
                              <div className="col-12 col-md-12 mb-4 position-relative">
                                <label className="form-label" >
                                  Old Password <span className="asterisk danger">*</span>
                                </label>

                                <input
                                  {...register("oldpassword", { required: "Old Password is required" })}
                                  className={`input ${errors.oldpassword ? "form-control required" : "form-control"
                                    }`}
                                  type="password"
                                  placeholder="Enter your old password"
                                />
                                {errors.oldpassword && (
                                  <div className="danger space-between">
                                    {errors.oldpassword.message}
                                  </div>
                                )}

                              </div>

                              <div className="col-12 col-md-12 mb-4 position-relative">
                                <label className="form-label" >
                                  New Password <span className="asterisk danger">*</span>
                                </label>

                                <input
                                  {...register("newpassword", {
                                    required: "New Password is required",
                                    pattern: {
                                      value: new RegExp(process.env.REACT_APP_PASSWORD_REGEX),
                                      message:
                                        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$&*)",
                                    },
                                  })}
                                  className={`input ${errors.newpassword ? "form-control required" : "form-control"
                                    }`}
                                  type="password"
                                  placeholder="Enter your new password"
                                />
                                {errors.newpassword && (
                                  <div className="danger space-between">
                                    {errors.newpassword.message}
                                  </div>
                                )}

                              </div>

                              <div className="col-12 col-md-12 mb-4 position-relative">
                                <label className="form-label" >
                                  Confirm Password <span className="asterisk danger">*</span>
                                </label>
                                <input
                                  {...register("confirmpassword", {
                                    required: "Confirm Password is required",
                                    validate: {
                                      passwordEqual: (value) =>
                                        value === getValues().newpassword || "Passwords do not match",
                                    },
                                  })}
                                  className={`input ${errors.confirmpassword ? "form-control required" : "form-control"
                                    }`}
                                  type="password"
                                  placeholder="Confirm Password"
                                />
                                {errors.confirmpassword && (
                                  <div className="danger space-between">
                                    {errors.confirmpassword.message}
                                  </div>
                                )}
                              </div>

                            </div>

                            {/* Action Buttons */}
                            <div className="d-flex align-items-center gap-3">
                              <button
                                type="button"
                                className="btn btn-dark"
                                onClick={onReset}
                              >
                                Cancel
                              </button>
                              <button className="btn btn-primary" type="submit">
                                {viewLoader && (
                                  <div className="loader-wrapper">
                                    <span className="loader-icon"></span>
                                  </div>
                                )}
                                Reset Password
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ResetPassword;
